<div class="app-root-container">
  <router-outlet ></router-outlet>
<!--
  <app-header (toggleSidenav)="sidenav.toggle()"></app-header>
  <app-breadcrumb></app-breadcrumb>
  
  <mat-sidenav-container class="app-body-container">
    
    <mat-sidenav #sidenav mode="over" class="app-sidenav">
      <app-sidebar></app-sidebar>
    </mat-sidenav>
    
    <mat-sidenav-content class="app-content">
      <main class="main-content">
        <router-outlet></router-outlet>
      </main>
    </mat-sidenav-content>

  </mat-sidenav-container>
  
  <app-footer></app-footer>
  -->
</div>